export default "__VITE_ASSET__CDE2pXZR__"